$(document).ready(function(){
$('.review-slider-outer').slick({
  infinite: true,
  centerMode: true,
  centerPadding: '300px',
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        centerPadding: '100px',
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
         centerPadding: '100px',
        slidesToScroll: 1

      }
    },
     {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        centerPadding: '0px',
        slidesToScroll: 1
      }
    }
  ]
});

// add active class to selected product price 
  $('.selected-product-details').click(function(){
    if ($('.selected-product-details').hasClass('active')){
      $('.selected-product-details').removeClass('active');
    }
    $(this).addClass('active');
  });

// tab

$('.tab-content').first().show();
      $('#tabs-nav li').click(function(){
     $('#tabs-nav li').removeClass('active');
     $(this).addClass('active');
     $('.tab-content').hide();
      var activeTab = $(this).find('a').attr('href');
        console.log(activeTab,'activeTab');
      $(activeTab).fadeIn();
      return false;
  });

  
$('.product-information-detail').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 821,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(".outer-recent-project .tab-outer-section .tab-heading").click(function(){
    $('.outer-recent-project .tab-heading').removeClass("active");
    var data = $(this).attr("data-tab");
    $(this).addClass("active");
    $('.outer-recent-project .cstm-outer-wrapper').removeClass("active");
    $('#'+data).addClass("active");
    
});
});